// =============================================================================
// src/views/camadas/camadas-presets.ts — Paletas e rotulos da Tela 05 (Camadas).
//
// Proveniencia: assets/unified-app.js Sections.camadas (linhas 1391-1502).
//   `presets`  -> CAMADAS_PRESETS         (cores por zona de cada preset)
//   labels/colors de _addIntensityMarkers -> INTENSITY_* (rotulo/cor por zona)
//   defaults activePreset='voto' / activeOpacity=0.70 -> CAMADAS_DEFAULT_*.
//   Cores/strings copiadas verbatim — sao paridade visual, NAO "limpar".
//
// SRP: so dados/constantes da secao Camadas. Sem DOM, sem Leaflet, sem listeners.
// =============================================================================

import type { ZonaKey, HexColor } from '../../app/types';

/** Chave de preset do estudio de camadas (data-preset no markup + presets do legado). */
export type CamadasPresetKey = 'voto' | 'vulnerabilidade' | 'renda' | 'pertencimento';

/** Preset inicial ao ativar a secao (Sections.camadas.activePreset legado). */
export const CAMADAS_DEFAULT_PRESET: CamadasPresetKey = 'voto';

/** Opacidade inicial das zonas (Sections.camadas.activeOpacity legado = 0.70). */
export const CAMADAS_DEFAULT_OPACITY = 0.70;

/** Piso de opacidade ao ler o slider (Math.max(0.15, val/100) no legado). */
export const CAMADAS_MIN_OPACITY = 0.15;

/**
 * Cor de preenchimento por zona para cada preset (Sections.camadas.presets).
 * `_applyStyles` cai em `voto` quando o preset corrente nao existe (|| presets.voto).
 */
export const CAMADAS_PRESETS: Record<CamadasPresetKey, Record<ZonaKey, HexColor>> = {
  voto: { norte: '#1D9E75', leste: '#1D9E75', 'centro-oeste': '#639922', 'centro-sul': '#185FA5', oeste: '#E24B4A', sul: '#378ADD' },
  vulnerabilidade: { norte: '#E24B4A', leste: '#F09595', 'centro-oeste': '#F7C1C1', 'centro-sul': '#FCEBEB', oeste: '#A32D2D', sul: '#F09595' },
  renda: { norte: '#97C459', leste: '#639922', 'centro-oeste': '#3B6D11', 'centro-sul': '#0F6E56', oeste: '#C0DD97', sul: '#639922' },
  pertencimento: { norte: '#3B6D11', leste: '#639922', 'centro-oeste': '#97C459', 'centro-sul': '#C0DD97', oeste: '#3B6D11', sul: '#97C459' },
};

/** Rotulo do marcador de intensidade por zona (_addIntensityMarkers.labels). */
export const INTENSITY_LABEL_BY_ZONE: Record<ZonaKey, string> = {
  norte: 'V↑', leste: 'E↑', 'centro-oeste': 'R↑', 'centro-sul': 'V↑', oeste: 'V↓', sul: 'E↓',
};

/** Cor do marcador de intensidade por zona (_addIntensityMarkers.colors). */
export const INTENSITY_COLOR_BY_ZONE: Record<ZonaKey, HexColor> = {
  norte: '#1D9E75', leste: '#185FA5', 'centro-oeste': '#639922', 'centro-sul': '#185FA5', oeste: '#E24B4A', sul: '#378ADD',
};

/** Cor de fallback de zona sem preset (`palette[zonaKey] || '#888780'`). */
export const CAMADAS_FALLBACK_FILL: HexColor = '#888780';

/** Cor de fallback de rotulo/cor de intensidade ausente (`|| '#888'` / `|| '·'`). */
export const INTENSITY_FALLBACK_COLOR: HexColor = '#888';
export const INTENSITY_FALLBACK_LABEL = '·';
